import { Block } from '@xprog/prensa'
import { ButtonProps } from '@xprog/prensa/types'
import React, { useState }  from 'react'
import AudioPlayer from 'react-h5-audio-player'
export interface OuvirMateriaButton extends ButtonProps {
  icon: any;
}

const OuvirMateriaButton: React.FC<OuvirMateriaButton> = ({ icon, ...otherProps }) => {

  return (

    <Block css={{ 
        align: ['row', 'right', 'middle'], 
        color: '$primaryMain',
        fontFamily: '$primary',
        fontSize: '$paragraph3',
        fontWeight: '$paragraph3',
        lineHeight: '$paragraph3',
        width: '100%',
        '.rhap_play-pause-button':{
          align: ['row', 'right', 'middle'],
          color:'white',
          fontSize: '20px',
          svg:{
            backgroundColor:'$primaryMain'
          }
        },
        '.rhap_controls-section':{
          marginBottom: '0px'
        },
        '.rhap_container':{
          width:'auto',
        }
      }}>
        <AudioPlayer
          src='https://www.appradio.app:8107/live'
          layout='stacked-reverse'
          showSkipControls={false}
          showJumpControls={false}
          customVolumeControls={[]}
          customAdditionalControls={[]}
          customProgressBarSection={[]}
        />
        Ouvir Matéria
    </Block>
  )
}

export default OuvirMateriaButton